/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBaseData } from './companyBaseData';
import { ClientsConfiguration } from './clientsConfiguration';
import { RoleConfiguration } from './roleConfiguration';


export interface UserAccessGroupAgency { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    isActive: boolean;
    isSystem?: boolean;
    roles: Array<RoleConfiguration>;
    key: string;
    agency: CompanyBaseData;
    allClients?: boolean;
    clients?: Array<ClientsConfiguration>;
}

